import { CenterReportFreeActivity } from '@/module/Laboratory/criteria/CenterReportFreeActivity';
import { CenterReportFreeText } from '@/module/Laboratory/criteria/CenterReportFreeText';
import { ReportCriteriaFreeType } from '@/module/ResearchCenter';

import { Id } from '@feature/utils';

interface CenterReportCriteriaSelectProps {
  labId: Id;
  criteriaCode: string;
  freeType: ReportCriteriaFreeType;
}

export function CenterReportCriteriaFree({ labId, criteriaCode, freeType }: CenterReportCriteriaSelectProps) {
  return (
    <>
      {freeType === 'FREE_TEXT' && (
        <CenterReportFreeText
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
      {freeType == 'ACTIVITY_VISIBILITY' && (
        <CenterReportFreeActivity
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
    </>
  );
}
